import { render, staticRenderFns } from "./NsHeaderTop.vue?vue&type=template&id=510c4433&scoped=true&"
import script from "./NsHeaderTop.vue?vue&type=script&lang=js&"
export * from "./NsHeaderTop.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderTop.vue?vue&type=style&index=0&id=510c4433&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c4433",
  null
  
)

export default component.exports